// utils/logger.js - Environment-based logging utility
const isDevelopment = process.env.NODE_ENV === 'development';

export const logger = {
  // Development only logs
  debug: (...args) => isDevelopment && console.debug('[DEBUG]', ...args),
  log: (...args) => isDevelopment && console.log('[LOG]', ...args),
  
  // Always show these (important for production monitoring)
  info: (...args) => console.info('[INFO]', ...args),
  warn: (...args) => console.warn('[WARN]', ...args),
  error: (...args) => console.error('[ERROR]', ...args),
  
  // Special methods for specific use cases
  sip: (...args) => isDevelopment && console.log('[SIP]', ...args),
  connection: (...args) => isDevelopment && console.log('[CONNECTION]', ...args),
  call: (...args) => isDevelopment && console.log('[CALL]', ...args),
  cdr: (...args) => isDevelopment && console.log('[CDR]', ...args),
  
  // Performance logging (always enabled but throttled)
  performance: (message, duration) => {
    if (duration > 1000 || isDevelopment) {
      console.info(`[PERF] ${message}: ${duration.toFixed(2)}ms`);
    }
  },
  
  // Network quality (production relevant)
  quality: (status, rtt, details) => {
    if (status === 'poor' || status === 'disconnected' || isDevelopment) {
      console.info(`[QUALITY] ${status.toUpperCase()} - RTT: ${rtt}ms`, details);
    }
  }
};

// Performance measurement utility
export const measurePerformance = async (name, asyncFn) => {
  const start = performance.now();
  try {
    const result = await asyncFn();
    const duration = performance.now() - start;
    logger.performance(name, duration);
    return result;
  } catch (error) {
    const duration = performance.now() - start;
    logger.error(`${name} failed after ${duration.toFixed(2)}ms:`, error);
    throw error;
  }
};

export default logger;